import React from 'react'

import { CarouselControlDirection } from '@adUtilities/constants/carousel'

interface ComponentProps {
  currentSlideIndex: number
  totalItem: number
  handleItemClick: (itemIndex: number) => void
  direction?: CarouselControlDirection
}

function Scrollbar({
  currentSlideIndex,
  totalItem,
  handleItemClick,
  direction = CarouselControlDirection.Horizontal,
}: ComponentProps) {
  return (
    <div
      className={`relative flex ${
        direction === CarouselControlDirection.Horizontal
          ? 'h-[5px]'
          : 'h-full w-[5px] flex-col'
      } flex-nowrap rounded-md bg-white/[0.35]`}
    >
      {Array.from({ length: totalItem }).map((_, index) => (
        <div
          key={index as number}
          className="flex-1 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation()
            handleItemClick(index)
          }}
          role="none"
        />
      ))}
      <div
        className={`absolute left-0 top-0 z-1 cursor-pointer rounded-md bg-white/80 transition-transform duration-300 ${
          direction === CarouselControlDirection.Horizontal
            ? 'h-full'
            : 'w-full'
        }`}
        style={{
          ...(direction === CarouselControlDirection.Horizontal && {
            width: `${100 / totalItem}%`,
            transform: `translateX(${currentSlideIndex * 100}%)`,
          }),
          ...(direction === CarouselControlDirection.Vertical && {
            height: `${100 / totalItem}%`,
            transform: `translateY(${currentSlideIndex * 100}%)`,
          }),
        }}
      />
    </div>
  )
}

export default Scrollbar
